import React from 'react';
import spinner from '../assets/spinner.gif';

function Spinner() {
  return (
    <div className="spinner-box">
      <img src={spinner} alt="loader" className="spinner" />
    </div>
  );
}

export default Spinner;
